import { getModuleLabel, type WorkshopModule } from '@mustauto/types';
import { cn } from '@mustauto/ui/web';

/**
 * Escolha única de tipo de serviço (mecânica, funilaria, estética). Usada na
 * abertura de OS e no padrão da abertura, em Configurações.
 *
 * Radio de verdade, e com a mesma cara da escolha do alerta de OS parada: é
 * escolha única, e não pode se parecer com os chips de especialidade (que
 * marcam vários).
 */
export function ModuleRadioGroup({
  name,
  label,
  options,
  value,
  onChange,
  suggested,
  disabled,
}: {
  name: string;
  /** Rótulo acessível do grupo. */
  label: string;
  options: readonly WorkshopModule[];
  value: WorkshopModule | null;
  onChange: (module: WorkshopModule) => void;
  /** Marca a opção com "sugerido" — o padrão que sai das especialidades. */
  suggested?: WorkshopModule;
  disabled?: boolean;
}) {
  return (
    <div role="radiogroup" aria-label={label} className="flex flex-wrap gap-2">
      {options.map((module) => {
        const active = module === value;
        return (
          <label
            key={module}
            className={cn(
              'flex items-center gap-2 rounded-lg border px-3 py-2 text-sm transition-colors',
              'focus-within:outline-none focus-within:ring-2 focus-within:ring-ring focus-within:ring-offset-1',
              disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer',
              active
                ? 'border-primary bg-primary/10 font-medium text-foreground'
                : 'border-input text-muted-foreground hover:border-primary/50',
            )}
          >
            <input
              type="radio"
              name={name}
              value={module}
              checked={active}
              disabled={disabled}
              onChange={() => onChange(module)}
              className="border-input"
            />
            <span>{getModuleLabel(module)}</span>
            {suggested === module && <span className="text-xs text-muted-foreground">sugerido</span>}
          </label>
        );
      })}
    </div>
  );
}
